import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES, LOGO_URL } from "@/lib/api";
import { Mail, Phone, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-cream-warm border-t border-border-subtle mt-16 sm:mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="" className="h-11 w-11 sm:h-12 sm:w-12 object-contain" loading="lazy" />
              <div>
                <div className="font-display text-xl text-ink">Bedding Lounge</div>
                <div className="label-eyebrow text-[10px]">Soft Luxury · Nature</div>
              </div>
            </div>
            <p className="text-sm text-ink-soft leading-relaxed">
              Crafted comforts for Pakistani homes. Every thread, every shade — softness with intention.
            </p>
          </div>

          <div>
            <h4 className="label-eyebrow !text-[10px] sm:!text-xs mb-3 sm:mb-4">Shop</h4>
            <ul>
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="flex items-center min-h-[40px] text-sm text-ink hover:text-sage transition-colors">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-eyebrow !text-[10px] sm:!text-xs mb-3 sm:mb-4">Care</h4>
            <ul className="space-y-2 text-sm text-ink">
              <li>Cash on Delivery</li>
              <li>Pakistan-wide Shipping</li>
              <li>Easy Returns</li>
              <li>Customer Support</li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="label-eyebrow !text-[10px] sm:!text-xs mb-3 sm:mb-4">Reach Us</h4>
            <ul className="text-sm text-ink">
              <li>
                <a href="mailto:Beddinglounge@gmail.com" className="flex items-center gap-2 min-h-[44px] break-all hover:text-sage" data-testid="footer-email">
                  <Mail size={15} className="text-sage shrink-0" /> Beddinglounge@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+923354233258" className="flex items-center gap-2 min-h-[44px] hover:text-sage" data-testid="footer-phone">
                  <Phone size={15} className="text-sage shrink-0" /> +92 335 4233258
                </a>
              </li>
              <li>
                <a href="https://instagram.com/beddinglounge" target="_blank" rel="noreferrer" className="flex items-center gap-2 min-h-[44px] hover:text-sage" data-testid="footer-instagram">
                  <Instagram size={15} className="text-sage shrink-0" /> @beddinglounge
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 sm:mt-12 pt-6 sm:pt-8 border-t border-border-subtle flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-center">
          <div className="text-[10px] sm:text-xs text-ink-soft tracking-widest uppercase">© {new Date().getFullYear()} Bedding Lounge — All rights reserved</div>
          <div className="text-[10px] sm:text-xs text-ink-soft tracking-widest uppercase">Crafted with care · Made in Pakistan</div>
        </div>
      </div>
    </footer>
  );
}
